import { ReviewSortOrder } from 'types/graphql'

export type SortOrderOption = {
  key: ReviewSortOrder
  label: string
  paramName: string
}

/**
 * Maps params to enum keys for queries, but also defines what options should show in the order
 * popover, in which order, and with what label.
 */
export const SORT_OPTIONS: SortOrderOption[] = [
  { key: ReviewSortOrder.Recommended, label: 'Default', paramName: 'recommended' },
  { key: ReviewSortOrder.Latest, label: 'Newest first', paramName: 'newest' },
  { key: ReviewSortOrder.Oldest, label: 'Oldest first', paramName: 'oldest' },
  { key: ReviewSortOrder.Popular, label: 'Most helpful', paramName: 'popular' }
]

export const DEFAULT_SORT_OPTION = SORT_OPTIONS[0]

export const getSortOption = (key: ReviewSortOrder): SortOrderOption => {
  const option = SORT_OPTIONS.find((possible) => possible.key === key)
  if (option) {
    return option
  } else {
    throw new Error('Unknown sort order option')
  }
}

export const paramToSortOrder = (param: string | null, fallbackOptionKey: ReviewSortOrder): SortOrderOption => {
  const optionFromParam = SORT_OPTIONS.find((possible) => possible.paramName === param)
  return optionFromParam ?? getSortOption(fallbackOptionKey)
}
